export const contentCategories = [
    "Events & Announcements",
    "Road Trip Information",
    "Key Contacts",
    "Medical Resources",
]